import type { LessonRoomGuide } from './lesson-room-guides'

import { LessonRoomGuideCategory } from '../model/types/lesson-room/enums'
import screen1Avif from '../ui/images/manual-smartestminds/mcbook/screen-1.avif'
import screen1Webp from '../ui/images/manual-smartestminds/mcbook/screen-1.webp'
import screen2Avif from '../ui/images/manual-smartestminds/mcbook/screen-2.avif'
import screen2Webp from '../ui/images/manual-smartestminds/mcbook/screen-2.webp'
import screen3Avif from '../ui/images/manual-smartestminds/mcbook/screen-3.avif'
import screen3Webp from '../ui/images/manual-smartestminds/mcbook/screen-3.webp'
import screen4Avif from '../ui/images/manual-smartestminds/mcbook/screen-4.avif'
import screen4Webp from '../ui/images/manual-smartestminds/mcbook/screen-4.webp'
import screen5Avif from '../ui/images/manual-smartestminds/mcbook/screen-5.avif'
import screen5Webp from '../ui/images/manual-smartestminds/mcbook/screen-5.webp'
import screen6Avif from '../ui/images/manual-smartestminds/mcbook/screen-6.avif'
import screen6Webp from '../ui/images/manual-smartestminds/mcbook/screen-6.webp'
import screen7Avif from '../ui/images/manual-smartestminds/mcbook/screen-7.avif'
import screen7Webp from '../ui/images/manual-smartestminds/mcbook/screen-7.webp'
import screen8Avif from '../ui/images/manual-smartestminds/mcbook/screen-8.avif'
import screen8Webp from '../ui/images/manual-smartestminds/mcbook/screen-8.webp'
import screen9Avif from '../ui/images/manual-smartestminds/mcbook/screen-9.avif'
import screen9Webp from '../ui/images/manual-smartestminds/mcbook/screen-9.webp'
import laptopScreen1Avif from '../ui/images/manual-smartestminds/laptop/screen-1.avif'
import laptopScreen1Webp from '../ui/images/manual-smartestminds/laptop/screen-1.webp'
import laptopScreen2Avif from '../ui/images/manual-smartestminds/laptop/screen-2.avif'
import laptopScreen2Webp from '../ui/images/manual-smartestminds/laptop/screen-2.webp'
import laptopScreen3Avif from '../ui/images/manual-smartestminds/laptop/screen-3.avif'
import laptopScreen3Webp from '../ui/images/manual-smartestminds/laptop/screen-3.webp'
import laptopScreen4Avif from '../ui/images/manual-smartestminds/laptop/screen-4.avif'
import laptopScreen4Webp from '../ui/images/manual-smartestminds/laptop/screen-4.webp'
import androidScreen1Avif from '../ui/images/manual-smartestminds/android/screen-1.avif'
import androidScreen1Webp from '../ui/images/manual-smartestminds/android/screen-1.webp'
import androidScreen2Avif from '../ui/images/manual-smartestminds/android/screen-2.avif'
import androidScreen2Webp from '../ui/images/manual-smartestminds/android/screen-2.webp'
import androidScreen3Avif from '../ui/images/manual-smartestminds/android/screen-3.avif'
import androidScreen3Webp from '../ui/images/manual-smartestminds/android/screen-3.webp'
import androidScreen4Avif from '../ui/images/manual-smartestminds/android/screen-4.avif'
import androidScreen4Webp from '../ui/images/manual-smartestminds/android/screen-4.webp'
import iphoneScreen1Avif from '../ui/images/manual-smartestminds/iphone/screen-1.avif'
import iphoneScreen1Webp from '../ui/images/manual-smartestminds/iphone/screen-1.webp'
import iphoneScreen2Avif from '../ui/images/manual-smartestminds/iphone/screen-2.avif'
import iphoneScreen2Webp from '../ui/images/manual-smartestminds/iphone/screen-2.webp'
import iphoneScreen3Avif from '../ui/images/manual-smartestminds/iphone/screen-3.avif'
import iphoneScreen3Webp from '../ui/images/manual-smartestminds/iphone/screen-3.webp'
import iphoneScreen4Avif from '../ui/images/manual-smartestminds/iphone/screen-4.avif'
import iphoneScreen4Webp from '../ui/images/manual-smartestminds/iphone/screen-4.webp'
import iphoneScreen5Avif from '../ui/images/manual-smartestminds/iphone/screen-5.avif'
import iphoneScreen5Webp from '../ui/images/manual-smartestminds/iphone/screen-5.webp'
import iphoneScreen6Avif from '../ui/images/manual-smartestminds/iphone/screen-6.avif'
import iphoneScreen6Webp from '../ui/images/manual-smartestminds/iphone/screen-6.webp'
import iphoneScreen7Avif from '../ui/images/manual-smartestminds/iphone/screen-7.avif'
import iphoneScreen7Webp from '../ui/images/manual-smartestminds/iphone/screen-7.webp'
import iphoneScreen8Avif from '../ui/images/manual-smartestminds/iphone/screen-8.avif'
import iphoneScreen8Webp from '../ui/images/manual-smartestminds/iphone/screen-8.webp'
import iphoneScreen9Avif from '../ui/images/manual-smartestminds/iphone/screen-9.avif'
import iphoneScreen9Webp from '../ui/images/manual-smartestminds/iphone/screen-9.webp'
import iphoneScreen10Avif from '../ui/images/manual-smartestminds/iphone/screen-10.avif'
import iphoneScreen10Webp from '../ui/images/manual-smartestminds/iphone/screen-10.webp'

export const LESSON_ROOM_GUIDES_SMARTESTMINDS: Record<LessonRoomGuideCategory, LessonRoomGuide> = {
  [LessonRoomGuideCategory.Windows]: {
    category: LessonRoomGuideCategory.Windows,
    icon: { name: 'windows' },
    label: 'Windows laptop/PC',
    title: '❓If your cam & mic permissions are blocked, try this:',
    sections: [
      {
        label: '',
        steps: [
          { text: 'Click Start and open Settings', image: { avif: laptopScreen1Avif, webp: laptopScreen1Webp, width: 287, height: 204 } },
          { text: 'Click Privacy & security', image: { avif: laptopScreen2Avif, webp: laptopScreen2Webp, width: 242, height: 142 } },
          { text: 'Click Camera and click ON to allow access to your camera', image: { avif: laptopScreen3Avif, webp: laptopScreen3Webp, width: 262, height: 142 } },
          { text: 'Find your browser in the list of programs and make sure it is enabled', image: { avif: laptopScreen4Avif, webp: laptopScreen4Webp, width: 262, height: 142 } },
          { text: 'Then do the same for the microphone' },
        ],
      },
    ],
  },
  [LessonRoomGuideCategory.Macbook]: {
    category: LessonRoomGuideCategory.Macbook,
    icon: { name: 'apple' },
    label: 'Macbook/iMac',
    title: '❓If your cam & mic permissions are blocked, try this:',
    sections: [
      {
        label: 'Safari Browser:',
        steps: [
          { text: 'If you see this screen', image: { avif: screen1Avif, webp: screen1Webp, width: 300, height: 138 } },
          { text: 'Press the key combination Command + R', image: { avif: screen2Avif, webp: screen2Webp, width: 259, height: 91 } },
          { text: 'After the page reloads, click "Allow" in the permissions pop-up', image: { avif: screen3Avif, webp: screen3Webp, width: 236, height: 236 } },
        ],
      },
      {
        label: 'Google Chrome Browser:',
        steps: [
          { text: 'Check if there is such an icon at the end of the URL line. If so, click on it.', image: { avif: screen4Avif, webp: screen4Webp, width: 264, height: 223 } },
          { text: 'Then click Open Settings', image: { avif: screen5Avif, webp: screen5Webp, width: 268, height: 144 } },
          { text: 'After opening the settings, click on checkbox near the browser icon, then "allow”', image: { avif: screen6Avif, webp: screen6Webp, width: 300, height: 264 } },
          { text: 'Then click “later”', image: { avif: screen7Avif, webp: screen7Webp, width: 300, height: 264 } },
          { text: 'Then go to the microphone item click on checkbox near the browser icon', image: { avif: screen8Avif, webp: screen8Webp, width: 300, height: 264 } },
          { text: 'Press Quit & Reopen', image: { avif: screen9Avif, webp: screen9Webp, width: 300, height: 264 } },
          { text: 'After Chrome has opened again, open the link to the demo lesson again. Then turn on Camera & Mic and Join meeting' },
        ],
      },
    ],
  },
  [LessonRoomGuideCategory.IphoneIpad]: {
    category: LessonRoomGuideCategory.IphoneIpad,
    icon: { name: 'apple' },
    label: 'iPhone/iPad',
    title: '❓If your cam & mic permissions are blocked, try this:',
    sections: [
      {
        label: 'Safari Browser',
        steps: [
          { text: 'If you see this screen. Click on the “Reload” icon at the end of the URL line', image: { avif: iphoneScreen1Avif, webp: iphoneScreen1Webp, width: 249, height: 158 } },
          { text: 'After the page reloads, click "Allow" in the permissions pop-up', image: { avif: iphoneScreen2Avif, webp: iphoneScreen2Webp, width: 236, height: 236 } },
        ],
      },
      {
        label: 'Google Chrome Browser',
        steps: [
          { text: 'If you see this screen. Click on the “Reload” icon before the URL line', image: { avif: iphoneScreen3Avif, webp: iphoneScreen3Webp, width: 249, height: 158 } },
          { text: 'After the page reloads, click "Allow" in the permissions pop-up', image: { avif: iphoneScreen4Avif, webp: iphoneScreen4Webp, width: 236, height: 236 } },
          { text: 'If this does not help, open the Settings of your iPad', image: { avif: iphoneScreen5Avif, webp: iphoneScreen5Webp, width: 293, height: 125 } },
          { text: 'Then select the Privacy & Security section; Find and click on the Microphone item', image: { avif: iphoneScreen6Avif, webp: iphoneScreen6Webp, width: 300, height: 210 } },
          { text: 'Find Chrome in the apps list and enable the option. After that, go to the previous Privacy & Security page.', image: { avif: iphoneScreen7Avif, webp: iphoneScreen7Webp, width: 300, height: 210 } },
          { text: 'Find and click on the Camera item', image: { avif: iphoneScreen8Avif, webp: iphoneScreen8Webp, width: 300, height: 210 } },
          { text: 'Find Chrome in the apps list and enable the option.', image: { avif: iphoneScreen9Avif, webp: iphoneScreen9Webp, width: 300, height: 210 } },
          { text: 'You can now reopen Chrome. Reload the page if it doesn\'t reload on its own. After the page reloads, click "Allow" or “OK” in the permissions pop-up', image: { avif: iphoneScreen10Avif, webp: iphoneScreen10Webp, width: 236, height: 236 } },
        ],
      },
    ],
  },
  [LessonRoomGuideCategory.Android]: {
    category: LessonRoomGuideCategory.Android,
    icon: { name: 'android' },
    label: 'Android phone or tablet',
    title: '❓If your cam & mic permissions are blocked, try this:',
    sections: [
      {
        label: 'Google Chrome Browser*',
        steps: [
          { text: 'If you see this screen. Click on the settings icon at the beginning of the URL line.', image: { avif: androidScreen1Avif, webp: androidScreen1Webp, width: 287, height: 174 } },
          { text: 'In the window that appears, select Permissions', image: { avif: androidScreen2Avif, webp: androidScreen2Webp, width: 287, height: 189 } },
          { text: 'Then turn on the Camera and Microphone permissions.', image: { avif: androidScreen3Avif, webp: androidScreen3Webp, width: 287, height: 228 } },
          { text: 'Click on the “Reload” icon before the URL line. Enjoy the lesson', image: { avif: androidScreen4Avif, webp: androidScreen4Webp, width: 283, height: 78 } },
        ],
      },
    ],
  },
}
